import { api, axios, Env, IAdminPage } from "@ancademy/vse-client";
import { ErrorMsg } from "@ancademy/vse-share";
import { IExtraStat } from "@share";
import { Button, Card, Col, DatePicker, message, Popover, Row, Skeleton, Space, Statistic, Table } from "antd";
import zh_cn from "antd/es/date-picker/locale/zh_CN";
import "dayjs/locale/zh-cn";
import { Moment } from "moment";
import React, { useEffect, useState } from "react";

function Statistics() {
  const [loading, setLoading] = useState(true);
  const [timeRange, setTimeRange] = useState([null, null] as any as [Moment, Moment]);
  const [data, setData] = useState(null as IExtraStat);
  const fetchData = async () => {
    setLoading(true);
    const res = await axios.get(`${Env.basePath}/extra/stat`, {
      params: {
        startTime: timeRange?.[0]?.toISOString(),
        endTime: timeRange?.[1]?.toISOString(),
      },
    });
    setData(res.data);
    setLoading(false);
  };
  useEffect(() => {
    fetchData().catch();
  }, []);
  if (!data) {
    return <Skeleton />;
  }
  return (
    <Card
      title="详细信息"
      extra={
        <Space>
          <DatePicker.RangePicker locale={zh_cn} value={timeRange} onChange={(moments) => setTimeRange(moments)} />
          <Button loading={loading} onClick={() => fetchData()}>
            查询
          </Button>
        </Space>
      }
    >
      <Row gutter={16}>
        <Col span={8}>
          <Statistic title="实验浏览人数" value={data.totalVisit} />
          <Statistic title="使用教师人数" value={data.teacherAmount} />
        </Col>
        <Col span={8}>
          <Statistic title="实验参与人数" value={data.resultAmount} />
          <Statistic title="使用学生人数" value={data.studentAmount} />
        </Col>
        <Col span={8}>
          <Statistic
            title="参与学校"
            valueRender={() => (
              <Popover
                content={
                  <Table
                    size="small"
                    bordered={false}
                    pagination={false}
                    dataSource={data.schoolAmountList}
                    rowKey="name"
                    columns={[
                      {
                        title: "学校",
                        dataIndex: "name",
                      },
                      {
                        title: "人数",
                        dataIndex: "count",
                      },
                    ]}
                  />
                }
              >
                <a>{data.schoolAmountList.length}</a>
              </Popover>
            )}
          />
          <Statistic title="平均实验时间" value={`${data.avgTime}s`} />
        </Col>
      </Row>
    </Card>
  );
}

export const wrapStatisticsPage = (page: IAdminPage) => ({
  ...page,
  Component: () => (
    <>
      <Statistics />
      <br />
      <Card title="数据备份">
        <Button
          type="primary"
          onClick={async () => {
            try {
              await api.backupDB();
              message.success("备份成功，并已加密传输至远端");
            } catch (err) {
              switch (err) {
                case ErrorMsg.DB_DUMP_FAILED:
                  message.error("备份失败，请查看服务器日志");
                  break;
                case ErrorMsg.UPLOAD_DB_DUMP_FAILED:
                  message.warn("备份成功，加密传输至远端失败");
                  break;
              }
            }
          }}
        >
          备份
        </Button>
      </Card>
    </>
  ),
});
